module.exports = __webpack_public_path__ + "static/media/addCart.7ea3811d.png";